import Payment from "@material-ui/icons/Payment";
import EditIcon from "@material-ui/icons/Edit";
import PostAddIcon from "@material-ui/icons/PostAdd";
import RouterIcon from "@material-ui/icons/Router";
import InfoIcon from "@material-ui/icons/Info";
import EventIcon from "@material-ui/icons/Event";

export const preinstallChecklistItems = [
  {
    path: "/preinstallpackage",
    title: "Internet Package",
    statusField: "packagestatus",
    icon: RouterIcon,
    text: "Click here to select your internet package.",
    shortformOnly: true,
  },
  {
    path: "/preinstalladditionalinfo",
    title: "Additional Information",
    statusField: "additionalinfostatus",
    icon: InfoIcon,
    text: "Click here to complete your install information.",
    shortformOnly: true,
  },
  {
    path: "/documentupload",
    title: "Documents",
    statusField: "documentstatus",
    icon: PostAddIcon,
    text: "Click here to upload your document.",
  },
  {
    path: "/autopayment",
    title: "Autopayment",
    statusField: "papstatus",
    icon: Payment,
    text: "Click here to upload payment method for your account.",
  },
  {
    path: "/contract",
    title: "Contract",
    statusField: "contractstatus",
    icon: EditIcon,
    text: "Click here to review and sign the contract.",
  },
  {
    path: "/preinstallschedule",
    title: "Schedule Install",
    statusField: "schedulestatus",
    icon: EventIcon,
    text: "Click here to choose an install appointment.",
    shortformOnly: true,
  },
];

// The overview and navigation must apply the same rules for the active contact.
export function getPreinstallChecklistItems(checklist) {
  const shortform = ["true", "1", "yes", "y"].includes(
    String(checklist.shortform).toLowerCase()
  );
  const hideDocuments = ["true", "1", "yes", "y"].includes(
    String(checklist.hidedocuments).toLowerCase()
  );

  return preinstallChecklistItems
    .filter(
      (item) =>
        (!item.shortformOnly || shortform) &&
        (item.path !== "/documentupload" || !hideDocuments)
    )
    .map((item) => ({ ...item, status: checklist[item.statusField] || "I" }));
}
